/**
 * Komponente ´Global Note´
 */

import {
	isElement
} from '../../../../shared/utils/is';
import {
	noop,
	extend,
	execute, executeAfterTransition
} from '../../../../shared/utils/index';

import SelectorEngine from '../../../../shared/dom/selector-engine';
import Data           from '../../../../shared/dom/data';
import EventHandler from '../../../../shared/dom/event-handler';
import Manipulator from "../../../../shared/dom/manipulator";

import Reveal from '../../../../shared/components/reveal/reveal';

// -------
// Private
// -------

const NAME       = 'global-note';
const DATA_KEY   = `ifab.${NAME}`;
const EVENT_KEY  = `.${DATA_KEY}`;
const API_KEY    = `.data-api`;

/**
 *
 * @param {HTMLElement} element
 * @param {Object} o
 * @returns {Object|null}
 * @constructor
 */
function GlobalNote(element, o = {}) {
	if (!isElement(element)) {
		return null;
	}

	// Wurde Element schon initialisiert?
	if (Data.get(element, `${DATA_KEY}.initialized`)) {
		return Data.get(element, API_KEY);
	}

	this.options = extend({}, GlobalNote.DEFAULTS, o);

	this._element  = element;

	// Aktueller Status.
	this._isOpen = false;

	// Rendering
	this._render();

	// API-Zugriffsmöglichkeiten
	const api = {
		hide : this.hide.bind(this),
		show : this.show.bind(this),
	};

	// API im Container verfügbar machen
	Data.set(this._element, API_KEY, api);

	// Initialisierungsstatus setzen.
	Data.set(this._element,`${DATA_KEY}.initialized`, true);

	return api;
}

/**
 * Standardoptionen.
 *
 * @constant {Object}
 */
GlobalNote.DEFAULTS = {
	cookie  : {
		name  : `ifab_${NAME}`,
		expire: 3600,
		hash  : '',
		isSet : false
	},
	onInit  : noop,
	onHidden: noop,
	onShown : noop
};

/**
 * Show Global Note
 */

GlobalNote.prototype.show = function() {
	// if (this._isOpen) {
	// 	return;
	// }

	this._isOpen = true;

	this._element.hidden = false;

	Reveal.show(this._element, {
		easing: 'ease-in'
	}).then(element => {
		executeAfterTransition(
			() => {
				execute(this.options.onShown);
			},
			this._element
		);
	});
};

//
// Hide Global Note
//

GlobalNote.prototype.hide = function(lasting = false) {
	if(lasting) {
		this._setCookie();
	}

	Reveal.hide(this._element, {
		easing: 'ease-out'
	}).then(element => {
		executeAfterTransition(
			() => {
				this.options.onHidden();

				// this._element.hidden = true;
				this._element.remove();
			},
			this._element
		);
	});
};

/**
 * Check Cookies for Global Note
 *
 * @returns {boolean}
 */
GlobalNote.prototype._getCookie = function() {
	if (this._isOpen) {
		return;
	}

	this.options.cookie.hash = this._createHash();

	let cookiestring = this.options.cookie.name + '=' + this.options.cookie.hash;

	return document.cookie.split(";").some((item) => item.trim().startsWith(cookiestring));
};

/**
 * Set Cookie for Global Note
 */
GlobalNote.prototype._setCookie = function() {
	let hash        = this.options.cookie.hash;
	let name        = this.options.cookie.name;
	let expire      = this.options.cookie.expire + 7200;
	let currentTime = new Date();
	let time        = currentTime.getTime();
	let expireTime  = time + parseInt(expire * 1000, 10);

	currentTime.setTime(expireTime);

	document.cookie = name + '=' + hash + '; expires=' + currentTime.toUTCString() + '; path=/';
};

/**
 * Create Hash for (Checking) Cookie
 *
 * @returns {number}
 */
GlobalNote.prototype._createHash = function() {
	let string = this._content.innerHTML;
	let hash   = 0;
	let i;
	let chr;

	if (string.length === 0) {
		return 0;
	}

	for (i = 0; i < string.length; i++) {
		// eslint-disable-next-line unicorn/prefer-code-point
		chr   = string.charCodeAt(i);
		hash  = ((hash << 5) - hash) + chr;
		// eslint-disable-next-line unicorn/prefer-math-trunc
		hash |= 0; // Convert to 32bit integer
	}

	return hash;
};

/**
 *
 * @returns {number}
 * @private
 */
GlobalNote.prototype._render = function() {
	this._content  = SelectorEngine.findOne(`.${NAME}__body`, this._element);
	this._btnClose = SelectorEngine.findOne(`.${NAME}-close`, this._element);
	this._btnHide  = SelectorEngine.findOne(`.${NAME}-hide`, this._element);

	this.options.cookie.isSet = this._getCookie();

	Reveal.hide(this._element, {
		duration: 0
	});

	EventHandler.on(this._btnClose, `click${EVENT_KEY}`, event => {
		event.preventDefault();

		this.hide();
	});

	EventHandler.on(this._btnHide, `click${EVENT_KEY}`, event => {
		event.preventDefault();

		this.hide(true);
	});

	if (this.options.cookie.isSet) {
		return 0;
	} else {
		window.pageInstance.globalNote = true;

		setTimeout(() => {
			this.show();
		}, 1000);
	}
};

// -------
// Public
// -------

/**
 * ´Global note´-Elemente zusammenstellen und initialisieren.
 */
const init = () => {
	const element = SelectorEngine.findOne(`[data-${NAME}]`);

	window.pageInstance.globalNote = false;

	let res = null;

	if (isElement(element)) {
		res = new GlobalNote(element);
	}

	return res;
};

// Export
export default {
	init: init
};
